// removed by extract-text-webpack-plugin
module.exports = {"icon":"_1hZjSVhGF-Aca23J85hpvu","icon-calendar":"_2dgLlLjwXdhdtJEqdNs92A","icon-list":"_1A8L5b2c__6a_9H9tf0-aC","icon-chart":"_2YW6_31BHIT7RnLmSWjQc4","icon-success":"_2nYDp6eMIZl3o10Wys2ILL","icon-warn":"vSn0Xv5lOZWIN6XJ8IpLG","icon-copy":"GyNTb48TaX2d1wNas58xb","icon-eye-close":"_2gIrFnf9jCwlowmBS5LrRY","icon-eye-open":"_3o-tz6ny-e712NgUeX3Ec6","icon-app":"_28KKJYnhc5T6YKPm9aY9bz","icon-consumption":"_19z7dyWwou_ZR5Dfdcgza7","icon-check":"_1xOvQRVFrj72vIlL_v9IXS"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Ficon/index.less
// module id = 350
// module chunks = 0